/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationPricingsGroupHealthMutation($input: SaveSimulationPricingsGroupHealth_M_simulation_pricings_group_healthInput!) {
    saveSimulationPricingsGroupHealth_M_simulation_pricings_group_health(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
